import React, { useState, useRef, useEffect } from 'react';
import { Clock, Globe } from 'lucide-react';
import CustomSelect from './CustomSelect';
import { TIMEZONES } from '../../lib/distributionService';

export default function DistributionTimePicker({
  timeValue = '00:00',
  timezoneValue = 'Asia/Kolkata',
  onTimeChange,
  onTimezoneChange,
}) {
  const [hours, setHours] = useState(timeValue ? timeValue.split(':')[0] || '00' : '00');
  const [minutes, setMinutes] = useState(timeValue ? timeValue.split(':')[1] || '00' : '00');

  useEffect(() => {
    if (timeValue) {
      const parts = timeValue.split(':');
      if (parts[0] !== undefined) setHours(parts[0]);
      if (parts[1] !== undefined) setMinutes(parts[1]);
    }
  }, [timeValue]);

  const hourOptions = Array.from({ length: 24 }).map((_, i) => String(i).padStart(2, '0'));
  const minuteOptions = Array.from({ length: 60 }).map((_, i) => String(i).padStart(2, '0'));

  const handleHourChange = (newHour) => {
    setHours(newHour);
    onTimeChange(`${newHour}:${minutes}`);
  };

  const handleMinuteChange = (newMin) => {
    setMinutes(newMin);
    onTimeChange(`${hours}:${newMin}`);
  };

  return (
    <div className="dist-rel-time-box">
      {/* Time Selector Group */}
      <div className="dist-rel-time-section">
        <label className="dist-label" style={{ marginBottom: '0.35rem' }}>
          <Clock size={14} color="#d9fb06" style={{ display: 'inline', marginRight: 4 }} />
          Release Time (24-Hour)
        </label>

        <div className="dist-rel-time-inputs">
          <div style={{ width: '68px' }}>
            <CustomSelect
              value={hours}
              options={hourOptions}
              onChange={handleHourChange}
              placeholder="00"
            />
          </div>
          <span style={{ fontSize: '1.1rem', fontWeight: 700, color: 'rgba(255,255,255,0.7)', margin: '0 0.15rem' }}>:</span>
          <div style={{ width: '68px' }}>
            <CustomSelect
              value={minutes}
              options={minuteOptions}
              onChange={handleMinuteChange}
              placeholder="00"
            />
          </div>
        </div>
      </div>

      {/* Timezone Selector Group */}
      <div className="dist-rel-timezone-section">
        <label className="dist-label" style={{ marginBottom: '0.35rem' }}>
          <Globe size={14} color="#d9fb06" style={{ display: 'inline', marginRight: 4 }} />
          Release Timezone
        </label>
        <CustomSelect
          value={timezoneValue}
          options={TIMEZONES}
          onChange={onTimezoneChange}
          placeholder="Select timezone..."
          searchable
        />
      </div>
    </div>
  );
}
